import { LeadForm, ApiProvider } from './form-common.js'

class LeadFormDefault extends LeadForm {
    constructor(config) {
        // Call the parent class constructor
        super(config)

        if (this.config.get('isModal') === false) {
            this.form.querySelectorAll('[data-form="control"]').forEach((element) => {
                applyToggle(element, 'protected', true)
            })
        }
    }

    calcStepProgress(stepSelectedId) {
        let inputValid = 0
        let inputCount = 1

        switch (stepSelectedId) {
            case 'stepDetails':
                inputCount = 5

                // first_name
                const inputFirstName = this.form.querySelector('#first_name')

                if (inputFirstName.classList.contains('is-valid')) {
                    inputValid += 1
                }

                // last_name
                const inputLastName = this.form.querySelector('#last_name')

                if (inputLastName.classList.contains('is-valid')) {
                    inputValid += 1
                }

                // zip_code
                const inputZip = this.form.querySelector('#zip_code')

                if (inputZip.classList.contains('is-valid')) {
                    inputValid += 1
                }

                // email
                const inputEmailAddress = this.form.querySelector('#email_address')

                if (inputEmailAddress.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
        }

        return inputValid / inputCount
    }

    stepShowSetup(stepSelectedId) {
        // Show tcpa info
        if (stepSelectedId === this.stepFinal) {
            this.form.querySelector('#tcpaInfo').style.display = 'block'
        } else {
            this.form.querySelector('#tcpaInfo').style.display = 'none'
        }

        // Hide elements depending on form step
        if (stepSelectedId !== this.stepFirst) {
            this.toggleElementsBasedOnFormStep(true)
        }

        this.stepCallback(stepSelectedId)
    }

    toggleElementsBasedOnFormStep(is_hidden) {
        const hideElements = document.querySelectorAll('[data-hidden="true"]')

        for (const hideElement of hideElements) {
            if (is_hidden === true) {
                hideElement.classList.add('hidden')
            } else {
                hideElement.classList.remove('hidden')
            }
        }
    }

    async stepCallback(stepSelectedId) {
        switch (stepSelectedId) {
            case 'stepDetails':
                // honey pot
                this.form.querySelector('#email_address_confirm').remove()
                break
        }
    }

    // See example on thehomesolarsource.com
    stepShowRules(stepElementKey) {
        return stepElementKey
    }

    handleFormSubmit() {
        const formData = new FormData(this.form)

        if (this.config.get('isModal') === false) {
            window.history.pushState({}, null, this.config.get('resultsURL'))

            this.historyStep = -1

            this.toggleElementsBasedOnFormStep(false)

            document.querySelector('#container-header').remove()
            this.containerForm.remove()

            // Mark as loading
            let buttonDownloadEbook = document.querySelector('#download-ebook')
                buttonDownloadEbook.style.cursor = 'wait'
                buttonDownloadEbook.addEventListener('click', preventDefault)
                buttonDownloadEbook.innerHTML = returnButtonProcessing('Preparing your eBook download')

            document.querySelector('#' + this.config.get('containerResultsID')).style.display = 'block'
            smoothScrollingTo('#' + this.config.get('containerResultsID'))

            // Adjust `overlay` display if exist
            this.displayOverlayIfExist(false) // It should be out at this point since this.containerForm has already been removed
        }

        if (getConfigValue('environment') === 'production') {
            setCookie('statusModalEbook', 1, 7200) // Needed even for non-modal form

            googleTriggerEvent('EbookFormSubmit')
        }

        // Process
        fetch(this.config.get('processURL'), {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
            },
        })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                if (this.config.get('isModal') === true) {
                    window.location = this.config.get('resultsURL')
                } else {
                    // Revert loading
                    let buttonDownloadEbook = document.querySelector('#download-ebook')
                        buttonDownloadEbook.style.cursor = 'pointer'
                        buttonDownloadEbook.removeEventListener('click', preventDefault)
                        buttonDownloadEbook.innerHTML = 'Download my free eBook'
                }

                if (response.success === false) {
                    debug(response)
                    throw new Error(response.message)
                }
            })
            .catch((error) => {
                debug(error)
            })
    }

    // ----------------------- Step checks ----------------------- //

    async stepDetailsCheck(stepElement, with_error, with_target, is_step_handle) {
        let error = false

        if (with_target == null || with_target === 'first_name') {
            const first_name = stepElement.querySelector('#first_name')

            if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
                error = true

                this.toggleError(first_name, stepElement, false, with_error)
            } else {
                this.toggleError(first_name, stepElement, true, with_error)
            }
        }

        if (with_target == null || with_target === 'last_name') {
            const last_name = stepElement.querySelector('#last_name')

            if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
                error = true

                this.toggleError(last_name, stepElement, false, with_error)
            } else {
                this.toggleError(last_name, stepElement, true, with_error)
            }
        }

        if (with_target == null || with_target === 'email_address') {
            const email_address = stepElement.querySelector('#email_address')

            if (isEmailAddress(email_address.value) === false) {
                error = true

                this.toggleError(email_address, stepElement, false, with_error)
            } else {
                this.toggleError(email_address, stepElement, true, with_error)
            }
        }

        if (with_target == null || with_target === 'zip_code') {
            const zip_code = stepElement.querySelector('#zip_code')

            if (zip_code.value.length !== 5 || zip_code.value === '00000') {
                error = true

                this.toggleError(zip_code, stepElement, false, with_error)
            } else {
                if (with_target == null) {
                    const zipData = await ApiProvider.getZipData(zip_code.value)

                    document.querySelector('#zip_country').value = zipData['country'] ?? ''
                    document.querySelector('#zip_state').value = zipData['state'] ?? ''
                    document.querySelector('#zip_city').value = zipData['city'] ?? ''

                    if (zipData['city'] === '' || zipData['city'] === 'undefined') {
                        error = true

                        this.toggleError(zip_code, stepElement, false, with_error)
                    } else {
                        this.toggleError(zip_code, stepElement, true, with_error)
                    }
                } else {
                    this.toggleError(zip_code, stepElement, true, with_error)
                }
            }
        }

        return error
    }

    // ----------------------- Step binds ----------------------- //

    stepDetailsBind(stepElement) {
        const idsElement = ['first_name', 'last_name', 'email_address', 'zip_code']

        // first_name
        let inputFirstName = stepElement.querySelector('#first_name')

        inputFirstName.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepDetailsCheck(stepElement, false, 'first_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputFirstName.addEventListener('change', async () => {
            await this.stepDetailsCheck(stepElement, false, 'first_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // last_name
        let inputLastName = stepElement.querySelector('#last_name')

        inputLastName.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepDetailsCheck(stepElement, false, 'last_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputLastName.addEventListener('change', async () => {
            await this.stepDetailsCheck(stepElement, false, 'last_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // email
        let inputEmailAddress = stepElement.querySelector('#email_address')

        inputEmailAddress.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepDetailsCheck(stepElement, false, 'email_address')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputEmailAddress.addEventListener('change', async () => {
            await this.stepDetailsCheck(stepElement, false, 'email_address')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // zip_code
        let inputZipCode = stepElement.querySelector('#zip_code')

        inputZipCode.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            event.target.value = event.target.value.slice(0, 5)

            await this.stepDetailsCheck(stepElement, false, 'zip_code')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputZipCode.addEventListener('change', async () => {
            await this.stepDetailsCheck(stepElement, false, 'zip_code')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })
    }
}

const setupForm = function (config) {
    new LeadFormDefault(config)
}

export default setupForm
